import axios from 'axios'

export default {
  fiPeerGroups(fiID) {
    return axios
      .get(`/api/peer_groups/?bank_id=${fiID}`, {
        handleErrors: true
      })
      .then(res => {
        return res.data
      })
  }
}
